import { supabase } from '@/lib/supabase';
import type { Review } from '@/types/db';

export async function getReviews(visibleOnly = false): Promise<Review[]> {
  let query = supabase.from('reviews').select('*').order('sort_order', { ascending: true });
  if (visibleOnly) query = query.eq('visible', true);
  const { data, error } = await query;
  if (error) throw error;
  return data ?? [];
}

export async function createReview(input: Partial<Review>): Promise<Review> {
  const { data, error } = await supabase.from('reviews').insert(input).select().single();
  if (error) throw error;
  return data;
}

export async function updateReview(id: string, patch: Partial<Review>): Promise<Review> {
  const { data, error } = await supabase.from('reviews').update(patch).eq('id', id).select().single();
  if (error) throw error;
  return data;
}

export async function deleteReview(id: string): Promise<void> {
  const { error } = await supabase.from('reviews').delete().eq('id', id);
  if (error) throw error;
}
